import React from 'react';

const LoadingCardRevampSkeleton = ({
  length = 1,
  isButtonSkeleton,
  isDegreeCard = false,
}: {
  length?: number;
  isButtonSkeleton: boolean;
  isDegreeCard?: boolean;
}) => {
  return (
    <div
      key={`loading-skeleton-${length}`}
      className="flex mt-5 relative !w-[302px] min-h-[335px] !mx-3 large:!mx-6 rounded-b-[4px] rounded-t-[4px] !shadow-light !shrink-0 flex-col bg-white !p-0 !m-0 animate-pulse cursor-pointer"
    >
      {/* Image Section */}
      <div className="bg-gray-300 rounded-[6px] w-full h-[154px] medium:w-[270px] medium:h-[154px]" />

      {/* Content Section */}
      <div className="flex flex-col gap-4 px-4 pb-4 pt-2">
        {/* Title Placeholder */}
        <div className="bg-gray-300 rounded h-4 w-full" />

        {/* Divider */}
        {!isDegreeCard && <div className="w-[270px] bg-gray-300 h-[1px]" />}

        {isDegreeCard && (
          <div className="flex gap-2">
            <div className="bg-gray-300 rounded h-2 w-full mt-2" />
          </div>
        )}

        {/* Meta Info */}
        {!isDegreeCard && (
          <div className="flex gap-2">
            <div className="flex items-center gap-1">
              <div className="bg-gray-300 rounded-full w-4 h-4" />
              <div className="bg-gray-300 rounded h-4 w-16" />
            </div>
            <div className="flex items-center gap-1">
              <div className="bg-gray-300 rounded-full w-4 h-4" />
              <div className="bg-gray-300 rounded h-4 w-24" />
            </div>
          </div>
        )}

        {/* Divider */}
        {isDegreeCard && <div className="w-[270px] bg-gray-300 h-[1px]" />}

        {/* Button Placeholder */}
        {isButtonSkeleton && <div className="bg-gray-300 rounded h-4 w-full mt-2" />}
      </div>
    </div>
  );
};

export default LoadingCardRevampSkeleton;
